import 'emoji-mart/css/emoji-mart.css'

import React, { useState, useRef, useEffect } from "react";
import { Picker } from "emoji-mart";
import styled from "styled-components";
import { useOutsideAlerter } from "./hooks";

import { ReactComponent as Emoji } from '../../Assets/SVG/Emoji.svg';

const Wrapper = styled.div`
  position: relative;
  margin-right: 4px;
  margin-left: 4px;
`;

const EmojiWrapper = styled.div`
  position: fixed;
  width: 100%;
  height: 100vh;
  top: 0;
  left: 0;
  background-color: rgba(0, 0, 0, 0.5);
  z-index: 9999;

    display: flex;
    align-items: center;
    justify-content: center;
`;

const EmojiContainer = styled.div`
  display: flex;
  flex-direction: column;
  // position: absolute;
  top: 50%;
  left: 50%;
  // transform: translate(-50%, -50%);
  justify-content: space-between;
  border-radius: 10px;
  background-color: rgba(0, 0, 0, 0.5);
`;

const IconWrapper = styled.div`
  cursor: pointer;
`;

const StyledFlexRow = styled.div`
  display: flex;
  justify-content: center;
  align-items: center;
  height: 100%;
`;

const EmojiPicker = ({ icon, reactionClick }) => {
  const [openPicker, setOpenPicker] = useState(false);
  const wrapperRef = useRef(null);
  const outsideClick = useOutsideAlerter(wrapperRef);

  useEffect(() => {
    if (outsideClick) {
      setOpenPicker(false);
    }
  }, [outsideClick, setOpenPicker]);

  const toggleOpen = () => {
    setOpenPicker(!openPicker);
  };

  return (
    <Wrapper>
      <StyledFlexRow alignItems="center" justifyContent="center">
        {icon ? (
          <IconWrapper onClick={toggleOpen}> {icon} </IconWrapper>
        ) : (
          <IconWrapper onClick={toggleOpen}><Emoji /></IconWrapper>
        )}

        {openPicker && (
          <EmojiWrapper>
            <EmojiContainer ref={wrapperRef}>
              <Picker
                emoji=""
                onSelect={(emoji) => {
                  reactionClick(emoji.native);
                  toggleOpen();
                }}
                theme="dark"
              />
            </EmojiContainer>
          </EmojiWrapper>
        )}
      </StyledFlexRow>
    </Wrapper>
  );
};

export { EmojiPicker };